import { Box, Typography } from '@mui/material';
interface LabelProps {
	cx: number;
	cy: number;
	midAngle: number;
	innerRadius: number;
	outerRadius: number;
	percent: number;
	index: number;
}

const RADIAN = Math.PI / 180;
export const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }: LabelProps) => {
	const radius = innerRadius + (outerRadius - innerRadius) * 0.6;
	const x = cx + radius * Math.cos(-midAngle * RADIAN);
	const y = cy + radius * Math.sin(-midAngle * RADIAN);

	return (
		<text x={x} y={y} fill="black" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
			{`${(percent * 100).toFixed(0)}%`}
		</text>
	);
};

export const renderCustomLegend = (props: any) => {
	const { payload } = props;

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, maxWidth: { md: '60px', lg: '100px' } }}>
			{payload.map((entry: any, index: number) => (
				<Box key={`item-${index}`} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
					<Box
						sx={{
							display: 'block',
							minWidth: 12,
							height: 12,
							borderRadius: '50%',
							backgroundColor: entry.color,
						}}
					/>
					<Typography
						noWrap
						title={entry.value}
						sx={{
							maxWidth: 125,
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							color: (theme) => theme.colors.grayLightBlue,
							fontSize: '14px',
							fontWeight: 400,
						}}
					>
						{entry.value}
					</Typography>
				</Box>
			))}
		</Box>
	);
};
